module.exports = new __parcel__URL__("write.fb0b7b16.wav").toString();